class EasterEgg {


    

    constructor() {

    }

    private isEnabled = false;

    private count:number = 0;

    private startEasterEgg () {
        let ee = document.createElement("div");
        ee.setAttribute("style", "z-index:9000; background: #c0c0c0");
        let eeScript: HTMLScriptElement = document.createElement("script");
        eeScript.src = "easter-eggs/snake-game.js";


        var appEl: any = document.getElementById("app");
        let snake = document.createElement("snake-game");
        let snakeWidth = 17 * 30;
        let docWith = appEl.clientWidth;
        console.log(docWith);
        if (docWith <= 0)
            docWith = document.body.clientWidth;
        let offsetX = (docWith - snakeWidth) / 2 / 30;
        offsetX = offsetX < 0 ? 0 : offsetX;
        offsetX = Math.floor(offsetX);
        snake.setAttribute("x", offsetX.toString());
        snake.setAttribute("y", "10");
        snake.setAttribute("width", "17");
        snake.setAttribute("height", "17");
        ee.appendChild(eeScript);
        ee.appendChild(snake);
        appEl.appendChild(ee);
    }


    private reset() {
        this.count = 0;
    }

    private inc() {
        this.count++;
    }

    
    private sorterEventListener(customEvent: CustomEvent, context: any) {
        if (!this.isEnabled)
            return;

        if (context.count === 0 &&
            customEvent.detail.sorterKey === "CreatedOn" &&
            customEvent.detail.sorterOrder === "asc") {
            context.inc();
        } else if (context.count === 1 &&
            customEvent.detail.sorterKey === "Relevance") {
            context.inc();
        } else if (context.count === 2 &&
            customEvent.detail.sorterKey === "CreatedOn" &&
            customEvent.detail.sorterOrder === "desc") {
            context.reset();
            context.startEasterEgg();
            
        } else {
            context.reset();
        }
    }

    currentHandler: any;

    public enable() {
        if (this.isEnabled)
            return;

        console.log("enable called!");
        this.currentHandler = (e:Event) => this.sorterEventListener(e as CustomEvent, this);
        document.addEventListener("sorterAdded", this.currentHandler);
        this.reset();
        this.isEnabled = true;
    }

    public disable() {
        if (!this.isEnabled)
            return;
        console.log("disable called!");
        document.removeEventListener("sorterAdded", this.currentHandler);
        this.currentHandler = null;
        this.reset();
        this.isEnabled = false;
    }

}

const easterEgg = new EasterEgg();
export  { easterEgg }